(function (angular) {
    "use strict";
  
    angular.module('myApp')
      .service('contactUsService', [
        '$http',
        function ($http) {
  
          var urlBase = 'api/contact-us/';
  
          this.save = function (dto) {
            return $http({
              url: urlBase,
              method: 'POST',
              data: dto
            });
          };
        }
      ]);
  
  }(window.angular));
